import {
  formatCurrency,
  defaultDateDisplay,
  defaultDateOnlyDisplay,
} from "../../../helpers";
import styles from "./styles.module.scss";
import { Link } from "react-router-dom";
import { pathConstants } from "../../../routes/pathContants";

const ChartAccountTransactionDetails = ({ chartAccountTransactionDetails }) => {
  const lineItem = chartAccountTransactionDetails?.journal_line_item;

  const formatAmount = (value) =>
    formatCurrency({
      value,
      currencyCode: chartAccountTransactionDetails?.store?.currencyCode,
    });

  return (
    <div className={styles.journalEntryDetails}>
      <div className={styles.journalEntryDetails__card}>
        <p className={styles.journalEntryDetails__description}>
          Review the source details and linked accounting records for this
          ledger movement, including original transaction line items and balance
          impact.
        </p>

        <div className={styles.summaryGrid}>
          <div className={styles.summaryCell}>
            <p>Transaction Type</p>
            <h5>Journal Entry</h5>
          </div>
          <div className={styles.summaryCell}>
            <p>Source</p>
            <h5>{chartAccountTransactionDetails?.source_label}</h5>
          </div>
          <div className={styles.summaryCell}>
            <p>Date</p>
            <h5>
              {defaultDateOnlyDisplay(
                chartAccountTransactionDetails?.transaction_date,
              )}
            </h5>
          </div>
          <div className={styles.summaryCell}>
            <p>Store</p>
            <h5>{chartAccountTransactionDetails?.store?.name}</h5>
          </div>
          <div className={styles.summaryCell}>
            <p>Created By</p>
            <h5>
              {chartAccountTransactionDetails?.initiator?.first_name}{" "}
              {chartAccountTransactionDetails?.initiator?.last_name}
            </h5>
          </div>
          <div className={styles.summaryCell}>
            <p>Customer / Counterparty</p>
            <h5>-</h5>
          </div>
          <div className={styles.summaryCell}>
            <p>Payment Method</p>
            <h5>{chartAccountTransactionDetails.payment_method_label}</h5>
          </div>
          <div className={styles.summaryCell}>
            <p>Total Amount</p>
            <h5 className={styles.totalAmount}>
              {formatAmount(
                chartAccountTransactionDetails?.debit_amount ??
                  0 + chartAccountTransactionDetails?.credit_amount ??
                  0,
              )}
            </h5>
          </div>
        </div>

        <div className={styles.overviewGrid}>
          <div className={styles.ledgerCard}>
            <h4>Ledger Account Detail</h4>

            <div className={styles.ledgerCard__meta}>
              <div>
                <p>Account Name</p>
                <h6>
                  {chartAccountTransactionDetails?.ledger_account?.account_name}
                </h6>
              </div>
              <div>
                <p>Account Code</p>
                <span>
                  {chartAccountTransactionDetails?.ledger_account?.account_code}
                </span>
              </div>
              <div>
                <p>Account Type</p>
                <h6>
                  {
                    chartAccountTransactionDetails?.ledger_account
                      ?.account_type_label
                  }
                </h6>
              </div>
              <div>
                <p>Narration</p>
                <h6>{lineItem?.description}</h6>
              </div>
            </div>

            <div className={styles.ledgerCard__totals}>
              <div>
                <p>Debit</p>
                <h3>
                  {chartAccountTransactionDetails?.debit_amount
                    ? formatAmount(chartAccountTransactionDetails?.debit_amount)
                    : "-"}
                </h3>
              </div>
              <div className={styles.creditBlock}>
                <p>Credit</p>
                <h3>
                  {chartAccountTransactionDetails?.credit_amount
                    ? formatAmount(
                        chartAccountTransactionDetails?.credit_amount,
                      )
                    : "-"}
                </h3>
              </div>
            </div>
          </div>
          <div className={styles.referenceGrid}>
            <div className={styles.referenceCard}>
              <p>Journal Reference</p>
              <h5>
                {
                  <Link
                    style={{ fontSize: "12px" }}
                    className="purple--text"
                    to={pathConstants.ACCOUNTING_JOURNAL_ENTRY_DETAILS({
                      reference: lineItem?.journal_entry?.reference,
                    })}
                  >
                    <span>{lineItem?.journal_entry?.reference}</span>
                  </Link>
                }
              </h5>
              <span className={styles.statusPosted}>
                {lineItem?.journal_entry?.status_label}
              </span>
            </div>

            <div className={styles.referenceCard}>
              <p>Transaction ID</p>
              <h5>#TRX-{chartAccountTransactionDetails?.id}</h5>
              <span className={styles.statusCompleted}>Completed</span>
            </div>

            <div className={styles.referenceCard__note}>
              <h5>Created On</h5>
              <p>
                {defaultDateDisplay(chartAccountTransactionDetails.created_at)}
              </p>
            </div>
          </div>
        </div>

        <div className={styles.tableSection}>
          <div className={styles.tableSection__header}>
            <h4>Source Line Item</h4>
            <p className="">Item linked to {lineItem?.reference}</p>
          </div>

          <div className={styles.tableWrapper}>
            <table>
              <thead>
                <tr>
                  <th>Reference</th>
                  <th>Description</th>
                  <th>TAX Rate (%)</th>
                  <th>TAX Amount</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{lineItem?.reference}</td>
                  <td>{lineItem?.description}</td>
                  <td>{lineItem?.tax_rate}</td>
                  <td>{formatAmount(lineItem?.tax_amount)}</td>
                  <td>
                    {formatAmount(
                      lineItem?.debit_amount || lineItem?.credit_amount,
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChartAccountTransactionDetails;
